<template>
  <footer
    :class="ns.b()"
    :style="style"
    data-test-name="footer"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </footer>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@bigin/hooks'

import type { CSSProperties } from 'vue'

defineOptions({
  name: 'BFooter',
})
const props = defineProps({
  height: {
    type: String,
    default: null,
  },
})

const ns = useNamespace('footer')

const style = computed(
  () =>
    (props.height
      ? ns.cssVarBlock({ height: props.height })
      : {}) as CSSProperties
)
</script>
